import {
    CalendarCheck,
    CalendarDays,
    ClipboardList,
    ContactRound,
    createIcons,
    CreditCard,
    Globe,
    Handshake,
    Heart,
    MessageCircleMore,
    Send,
    Sparkles,
} from 'lucide';

createIcons({
    icons: {
        CalendarCheck,
        CalendarDays,
        ClipboardList,
        ContactRound,
        CreditCard,
        Globe,
        Handshake,
        Heart,
        MessageCircleMore,
        Send,
        Sparkles,
    },
});
